(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["joie-lumiere-fr"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('joie-lumiere-fr')) {
  customElements.define('joie-lumiere-fr', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const configNode = this.querySelector('[data-sb-config]');
      if (!configNode) {
        this.parserObserver = new MutationObserver(() => {
          if (this.querySelector('[data-sb-config]')) {
            this.parserObserver.disconnect();
            this.connectedCallback();
          }
        });
        this.parserObserver.observe(this, { childList: true, subtree: true });
        return;
      }
      this.ready = true;
      this.events = new AbortController();
      const listen = (node, event, handler) => node.addEventListener(event, handler, { signal: this.events.signal });
      const config = JSON.parse(configNode.textContent);
      const cards = [...this.querySelectorAll('[data-pack]')];
      const button = this.querySelector('.ugx-cart');
      const message = this.querySelector('.ugx-msg');
      const sticky=this.querySelector('.lf-sticky');
      const stickyButton=this.querySelector('[data-sticky-add]');
      const stickyMessage=this.querySelector('[data-sticky-message]');
      const total = this.querySelector('.ugx-price strong');
      const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: config.currency || 'EUR' }).format(cents / 100);
      let busy = false;
      const active = () => cards.find(card => card.querySelector('input[type="radio"]').checked);
      const choices = card => card ? [...card.querySelectorAll('select')].map(select => ({ id: select.value, option: select.selectedOptions[0] })) : [];
      const valid = card => Boolean(card) && choices(card).length === Number(card.dataset.pack) && choices(card).every(choice => choice.id && choice.option && !choice.option.disabled);
      const price = card => choices(card).reduce((sum, choice) => sum + Number(choice.option?.dataset.price || 0), 0);
      const offer = card => {
        if (!card || !config.promo) return null;
        const count = Number(card.dataset.pack);
        if (count < 2) return null;
        const code = config['code' + count];
        const percent = Number(config['discount' + count]);
        return code && percent > 0 ? { code, percent } : null;
      };
      const discount = card => {
        const promotion = offer(card);
        if (!promotion) return 0;
        const lines = new Map();
        choices(card).forEach(choice => lines.set(choice.id, (lines.get(choice.id) || 0) + Number(choice.option?.dataset.price || 0)));
        return [...lines.values()].reduce((sum, amount) => sum + Math.round(amount * promotion.percent / 100), 0);
      };
      const payable = card => price(card) - discount(card);
      const update = () => {
        const selected = active();
        cards.forEach(card => {
          const on = card === selected;
          card.classList.toggle('is-active', on);
          card.querySelector('[data-fields]').hidden = !on;
          card.querySelector('input[type="radio"]').disabled = busy;
          card.querySelectorAll('select').forEach(select => { select.disabled = !on || busy; });
          card.querySelector('[data-pack-total]').textContent = valid(card) ? money(payable(card)) : 'Indisponible';
          const savings = card.querySelector('[data-savings]');
          const amount = discount(card);
          savings.hidden = !valid(card) || amount <= 0;
          savings.textContent = amount > 0 ? '−' + offer(card).percent + ' % · Vous économisez ' + money(amount) + ' par rapport à l’achat à l’unité · env. ' + money(Math.round(payable(card) / Number(card.dataset.pack))) + ' par rideau' : '';
        });
        total.textContent = valid(selected) ? money(payable(selected)) : 'Choisissez une variante disponible';
        const giftBox = this.querySelector('[data-door-gift]');
        if (giftBox) giftBox.hidden = Number(selected?.dataset.pack || 1) < 2;
        button.disabled = busy || !valid(selected);
        button.textContent = busy ? 'AJOUT EN COURS…' : valid(selected) ? 'AJOUTER AU PANIER →' : 'ACTUELLEMENT INDISPONIBLE';
        if(stickyButton){stickyButton.disabled=button.disabled;stickyButton.textContent=busy?'Ajout en cours…':valid(selected)?'Ajouter au panier':'Indisponible';this.querySelector('[data-sticky-price]').textContent=valid(selected)?money(payable(selected)):'—';this.querySelector('[data-sticky-selection]').textContent=(selected?.dataset.pack||1)+' rideau(x) · Modifier';}
      };
      if(stickyButton) listen(stickyButton,'click',()=>button.click());
      if(stickyMessage){this.messageObserver=new MutationObserver(()=>{stickyMessage.replaceChildren(...[...message.childNodes].map(n=>n.cloneNode(true)));});this.messageObserver.observe(message,{childList:true,subtree:true,characterData:true});}
      cards.forEach(card => listen(card, 'change', () => { message.textContent = ''; update(); }));
      this.querySelectorAll('.ugx-thumbs button').forEach((thumb, index) => {
        thumb.setAttribute('aria-pressed', String(index === 0));
        listen(thumb, 'click', () => {
          const image = this.querySelector('.ugx-primary img');
          image.removeAttribute('srcset');
          image.src = thumb.dataset.src;
          image.alt = thumb.querySelector('img').alt;
          this.querySelectorAll('.ugx-thumbs button').forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
        });
      });
      listen(button, 'click', async () => {
        if (busy || !valid(active())) return;
        const selected = active();
        const count = Number(selected.dataset.pack);
        const selectedOffer = offer(selected);
        const grouped = new Map();
        choices(selected).forEach(choice => grouped.set(choice.id, (grouped.get(choice.id) || 0) + 1));
        const items = [...grouped].map(([id, quantity]) => ({ id: Number(id), quantity }));
        busy = true;
        update();
        message.textContent = 'Votre lot de Noël est en préparation…';
        let sent = false;
        try {
          if (config.gift && count >= 2) {
            const check = await fetch(config.gift.url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
            if (!check.ok) throw new Error('Impossible de vérifier le cadeau pour le moment. Réessayez plus tard.');
            const giftProduct = await check.json();
            const gift = giftProduct.variants.find(item => String(item.id) === String(config.gift.id));
            if (!gift || !gift.available || Number(gift.price) !== 0) throw new Error('Le cadeau est actuellement indisponible. Actualisez la page.');
            items.push({ id: config.gift.id, quantity: 1, properties: { Cadeau: 'Guirlande de porte · Lot de Noël' } });
          }
          sent = true;
          const response = await fetch(config.addUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) {
            if (response.status === 422) throw new Error('Une variante est indisponible dans cette quantité. Choisissez une autre variante ou un lot plus petit.');
            throw new Error('Impossible d’ajouter votre lot. Vérifiez votre panier.');
          }
          if (config.preview) {
            message.textContent = 'Aperçu : le lot a été vérifié. Aucune commande n’a été passée.';
            this.dispatchEvent(new CustomEvent('jlfr:preview-add', { detail: { items, code: selectedOffer?.code || null } }));
            busy = false; update(); return;
          }
          window.location.assign(selectedOffer ? '/discount/' + encodeURIComponent(selectedOffer.code) + '?redirect=' + encodeURIComponent(config.cartUrl) : config.cartUrl);
        } catch (error) {
          message.textContent = error instanceof TypeError ? 'La connexion a été interrompue. Vérifiez votre panier avant de réessayer.' : error.message || 'Veuillez réessayer plus tard.';
          if (sent) {
            const link = document.createElement('a');
            link.href = config.cartUrl;
            link.textContent = ' Voir le panier →';
            message.append(link);
          }
          busy = false;
          update();
        }
      });
      update();
      const pause = this.querySelector('.sl-motion');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) this.classList.add('sl-paused');
      const pauseLabel = () => {
        const paused = this.classList.contains('sl-paused');
        pause.textContent = paused ? '▷ Activer les animations' : 'Ⅱ Mettre les animations en pause';
        pause.setAttribute('aria-pressed', String(paused));
      };
      pauseLabel();
      listen(pause, 'click', () => { this.classList.toggle('sl-paused'); pauseLabel(); });
      const snow = this.querySelector('.ugx-snow');
      snow.replaceChildren();
      if (!reduced) {
        for (let j = 0; j < (innerWidth < 700 ? 24 : 40); j++) {
          const flake = document.createElement('span');
          flake.className = 'ugx-flake'; flake.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M3.34 7l17.32 10M3.34 17L20.66 7M9 4l3 3 3-3M9 20l3-3 3 3M3.6 10.5l4.1-1.1-1.1-4.1M17.4 18.7l-1.1-4.1 4.1-1.1M3.6 13.5l4.1 1.1-1.1 4.1M17.4 5.3l-1.1 4.1 4.1 1.1"/></g></svg>';
          flake.style.left = (j * 71.37 % 100) + '%';
          flake.style.fontSize = (12 + j % 11) + 'px';
          flake.style.animationDuration = (9 + j % 14) + 's';
          flake.style.animationDelay = (-(j * 2.3) % 22) + 's';
          flake.style.setProperty('--ugx-fall-distance', (innerHeight + 80) + 'px');
          snow.append(flake);
        }
      }
      const clock = this.querySelector('[data-sb-countdown]');
      if (clock) {
        const target = Date.parse(clock.dataset.deadline);
        const output = clock.querySelector('[data-sb-time]');
        output.innerHTML=['JOURS','H','MIN','S'].map(label=>'<span><b>00</b><small>'+label+'</small></span>').join('');
        const digits=[...output.querySelectorAll('b')];
        const tick = () => {
          const seconds = Math.max(0, Math.floor((target - Date.now()) / 1000));
          if (!Number.isFinite(target) || seconds <= 0) { clock.hidden = true; clearInterval(this.timer); return; }
          [Math.floor(seconds/86400),Math.floor(seconds%86400/3600),Math.floor(seconds%3600/60),seconds%60].forEach((v,i)=>{digits[i].textContent=String(v).padStart(2,'0');});
        };
        tick();
        listen(document,'visibilitychange',()=>{if(!document.hidden)tick();});
        listen(window,'pageshow',tick);
        if (Number.isFinite(target) && target > Date.now()) this.timer = setInterval(tick, 1000);
      }
      if ('IntersectionObserver' in window && !reduced) {
        this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){entry.target.classList.add('lf-visible');this.revealObserver.unobserve(entry.target);}}),{threshold:0.08});
        this.querySelectorAll('.ugx-stepgrid article,.ugx-v5-photo,.lf-confidence-grid article,.ugx-v5-editorial').forEach(el=>{el.classList.add('lf-reveal');this.revealObserver.observe(el);});
      }
      const hero=this.querySelector('.ugx-hero');
      const syncSticky=()=>{
        if(!sticky)return;
        const rect=button.getBoundingClientRect();
        const mainVisible=rect.top>=0 && rect.bottom<=innerHeight;
        sticky.hidden=hero.getBoundingClientRect().top > -140;
      };
      if('IntersectionObserver' in window){this.buyObserver=new IntersectionObserver(syncSticky,{threshold:[0,1]});this.buyObserver.observe(hero);this.buyObserver.observe(button);}
      listen(window,'scroll',syncSticky);
      listen(window,'resize',syncSticky);
      syncSticky();
      const refreshCount = async () => {
        if (config.preview) return;
        try {
          const response = await fetch(config.rootUrl + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          const badge = this.querySelector('[data-cart-count]');
          badge.textContent = String(cart.item_count); badge.hidden = cart.item_count === 0;
        } catch (_) {}
      };
      listen(window, 'pageshow', refreshCount);
      listen(document, 'visibilitychange', () => { if (!document.hidden) refreshCount(); });
    }
    disconnectedCallback() {
      this.parserObserver?.disconnect();
      this.events?.abort();
      this.messageObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.buyObserver?.disconnect();
      clearInterval(this.timer);
      this.ready = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
